import React, { useState, useEffect, useContext } from "react";
import Holdings from "./Holdings/Holdings";
import RollingReturns from "./RollingReturns/RollingReturns";
import product_horizon1 from "../../../images/newIcon/product_horizon-01.svg";
import URLstateContext from "../../../provider/CommonContext";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import renderHTML from "react-render-html";
import { format, parseISO } from "date-fns";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import animation from "../../../images/jm-animation.gif";
import { log } from "util";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { useLocation, useParams } from "react-router-dom";
import { trackEvent, trackPageView } from "../../utils/tracking";

function FundSummery(props) {
  const { SchemeCode, schemeName } = useParams();
  const [dataMan, setDataMan] = useState([]);
  const [data, setData] = useState([]);
  const { BaseURL } = useContext(URLstateContext);
  let getSchemeCode = props.SchemeCode;
  const handleClose = () => setShow(false);
  const [dataSum, setDataSum] = useState([]);
  const [metaDescription, setMetaDescription] = useState("");
  const [show, setShow] = useState(false);
  const [loadingshow, setloadingshow] = useState(false);
  const [DataMisc, setDataMisc] = useState("");
  let getSchemeType = props.SchemeDesc.split("-")[0];

  const location = useLocation();

  // useEffect(() => {
  //   window.dataLayer = window.dataLayer || []; // Ensure dataLayer exists
  //   window.dataLayer.push({
  //     event: "jmf_products_landing", // Custom event name
  //     page: location.pathname, // Optional: Track the page path
  //   });
  // }, [location, data]);

  useEffect(() => {
    setloadingshow(true);

    GetPostMethodData(BaseURL + "GetFundManagers", {
      IVSchemeCode: getSchemeCode,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setDataMan(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
    //   GetPostMethodData(BaseURL + "GetFundSummary", {
    //     IVSchemeCode: getSchemeCode,
    //   }).then((data) => {
    //     setloadingshow(false);
    //     if (data.data != null && data.data.length > 0) {
    //       setData(DecryptAESdata(data.data));
    //       // alert()
    //       // console.log("2" + DecryptAESdata(data.data))
    //       setloadingshow(false);
    //     }
    //   });
    // }, [BaseURL]);

    GetPostMethodData(BaseURL + "GetFundSummary", {
      IVSchemeCode: SchemeCode,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        const gtmTag = DecryptAESdata(data.data)[0]?.GTMTagName;
        if (gtmTag) {
          const pageUrl = window.location.href;
          trackPageView(pageUrl, `${gtmTag}`);
          trackEvent({
            category: "Dynamic Page",
            action: "Product Page Loaded",
            label: `product_${gtmTag}_${schemeName}`,
          });
        }
        setloadingshow(false);
      }
    });
  }, [BaseURL, SchemeCode, schemeName]);

  // if (data[0] != undefined) {
  //     var suitableSummary = data[0].SuitableFor.split(",");
  // }
  useEffect(() => {
    GetPostMethodData(BaseURL + "Getmiscellaneous", {
      IVSubCategoryName: "Scheme Expense Ratio",
    })
      .then((data) => {
        if (data.data != null && data.data.length > 0) {
          setDataMisc(DecryptAESdata(data.data));
          // console.log("3" + DecryptAESdata(data.data))
        }
      })
      .catch((error) => {
        //  console.log(error);
      });
  }, []);
  const handleShow = (event) => {
    let ManId = event.currentTarget.dataset.id;
    GetPostMethodData(BaseURL + "GetProductFundManPopUp", {
      IVFundMgmtTeamId: ManId,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataSum(DecryptAESdata(data.data));
        // alert("4 :- " + DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
    setShow(true);
  };
  // function getDistinctValuesAsDict(list, key) {
  //   const distinctValuesSet = new Set(list.map((dict) => dict[key]));
  //   return Array.from(distinctValuesSet).map((value) => ({ [key]: value }));
  // }
  function getDistinctValuesAsDict(list, key) {
    // Check if list is an array before proceeding
    if (!Array.isArray(list)) {
      console.error("Input list is not an array.");
      return []; // Return an empty array or handle the error as needed
    }

    const distinctValuesSet = new Set(list.map((dict) => dict[key]));
    return Array.from(distinctValuesSet).map((value) => ({ [key]: value }));
  }
  return (
    <>
      <section className="product_fund-summary-sc" id="fund-summary-content">
        {loadingshow ? (
          <div className="textcentervertex HomeLoader">
            <img src={animation} alt="Loading" />
            <div className="model_popup">Please Wait...</div>
          </div>
        ) : (
          <div>
            {data && data.length === 0 ? (
              <h5 className="errormsgComNew">No Data Available</h5>
            ) : (
              <>
                {data &&
                  data.length > 0 &&
                  data.map(
                    ({
                      AdditionalBenchmarkIndex,
                      AllotmentDate,
                      fundtypedec,
                      ExpenseRatioDirect,
                      RegularInceptionDate,
                      DirectInceptionDate,
                      ExitLoad,
                      ExpenseRatioRegular,
                      MinimumApplicationAmount,
                      MonthlyAAum,
                      MonthlyEndAum,
                      benchmarkindex,
                      AsonDate,
                      MetaDescription,
                      MetaTitle,
                    }) => (
                      <>
                        <HelmetProvider>
                          <Helmet>
                            <meta charset="UTF-8" />
                            <meta
                              name="viewport"
                              content="width=device-width, initial-scale=1.0"
                            />
                            <meta
                              name="description"
                              content={MetaDescription}
                            />
                            <title>{MetaTitle}</title>
                          </Helmet>
                        </HelmetProvider>
                        {/* <p className="msg-label">
                          
                            {fundtypedec}
                        </p> */}
                        <div className="padding-box">
                          <div className="fund-size-container">
                            <div className="fund-flex">
                              {/* Fund Size */}
                              <ul className="sub-head">
                                <li className="asondate">
                                  <p className="hover-fund">
                                    Fund Size
                                    <span className="hover-text-summary">
                                      {/* {["J656", "J658"].includes(SchemeCode) ? (
                                        <>
                                          Since this is a new scheme, Month End
                                          AUM &amp;
                                          <br />
                                          Average Monthly AUM are not yet
                                          available.
                                        </>
                                      ) : (
                                        <> */}
                                          Assets Under Management (AUM) refers
                                          to the recent / updated cumulative
                                          market value of investments managed by
                                          a mutual fund or any investment firm.
                                        {/* </> */}
                                      {/* )} */}
                                    </span>
                                  </p>

                                  <p className="text-xsm">
                                    (As on -{" "}
                                    {AsonDate && AsonDate != null
                                      ? format(
                                          parseISO(AsonDate),
                                          "do MMM, yyyy",
                                        )
                                      : "--"}
                                    )
                                  </p>
                                </li>
                                <li>
                                  Month End AUM:{" "}
                                  <span>
                                    ₹{" "}
                                    {MonthlyEndAum && MonthlyEndAum != null
                                      ? MonthlyEndAum.toFixed(2)
                                      : "--"}{" "}
                                    Crore
                                  </span>
                                </li>

                                <li>
                                  Average Monthly AUM:{" "}
                                  <span>
                                    ₹{" "}
                                    {MonthlyAAum && MonthlyAAum != null
                                      ? MonthlyAAum.toFixed(2)
                                      : "--"}{" "}
                                    Crore
                                  </span>
                                </li>
                              </ul>

                              {/* Inception Date */}
                              <ul className="sub-head">
                                <li className="">
                                  <h6 className="">Inception Date</h6>
                                  {getSchemeType === "Regular" ? (
                                    <span>
                                      {RegularInceptionDate &&
                                      RegularInceptionDate != null
                                        ? format(
                                            parseISO(RegularInceptionDate),
                                            "do MMMM, yyyy",
                                          )
                                        : "--"}
                                    </span>
                                  ) : (
                                    <span>
                                      {DirectInceptionDate &&
                                      DirectInceptionDate != null
                                        ? format(
                                            parseISO(DirectInceptionDate),
                                            "do MMMM, yyyy",
                                          )
                                        : "--"}
                                    </span>
                                  )}
                                </li>
                              </ul>

                              {/* Expense Ratio */}
                              <ul className="sub-head">
                                <li>
                                  <p className="hover-fund">
                                    Expense Ratio
                                    {/* {["J656", "J658"].includes(SchemeCode) && (
                                      <span className="hover-text-summary">
                                        Since this is a new scheme, <br></br>
                                        Expense Ratio is not yet available.
                                      </span>
                                    )} */}
                                  </p>

                                  {getSchemeType === "Regular" ? (
                                    <span>
                                      Regular Plan :{" "}
                                      {ExpenseRatioRegular
                                        ? ExpenseRatioRegular
                                        : "--"}{" "}
                                      %
                                    </span>
                                  ) : (
                                    <span>
                                      Direct Plan :{" "}
                                      {ExpenseRatioDirect
                                        ? ExpenseRatioDirect
                                        : "--"}{" "}
                                      %
                                    </span>
                                  )}
                                </li>
                                <li>
                                  <p>To see the latest expense ratio </p>
                                  {DataMisc &&
                                    DataMisc.map(
                                      (
                                        { FileName, SubCategoryName },
                                        index,
                                      ) => (
                                        <a
                                          key={index}
                                          href="/Scheme-Expense-Ratio"
                                          aria-label="View Scheme Expense Ratio"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          // style={{ color: "#013C66" }}
                                        >
                                          <i
                                            class="fa fa-external-link"
                                            style={{ color: "#013c66" }}
                                          ></i>
                                        </a>
                                      ),
                                    )}
                                </li>
                              </ul>
                            </div>

                            {/* Exit Load */}
                            <div className="fund-flex">
                              <ul className="sub-head dots">
                                <li>
                                  <p className="hover-fund">
                                    Exit Load
                                    <span className="hover-text-summary">
                                      Exit load is charged at the time an
                                      investor redeems the units of a mutual
                                      fund. The exit load is deducted from the
                                      prevailing NAV at the time of redemption.
                                      For instance, if the NAV is Rs 100 and the
                                      exit load is 1%, the redemption price
                                      would be Rs 99 Per Unit
                                    </span>
                                  </p>
                                  <p>
                                    {ExitLoad != null
                                      ? renderHTML(ExitLoad)
                                      : ""}
                                  </p>
                                </li>
                              </ul>
                            </div>

                            {/* Benchmark Index */}
                            <div className="fund-flex">
                              <ul className="sub-head">
                                <li>
                                  <p className="hover-fund">
                                    Benchmark Index
                                    <span className="hover-text-summary">
                                      A group of securities, usually a market
                                      index, whose performance is used as a
                                      standard or benchmark to measure
                                      investment performance of mutual funds...
                                    </span>
                                  </p>
                                  <span>{benchmarkindex}</span>
                                </li>
                              </ul>

                              <ul className="sub-head">
                                <li>
                                  <h6>Additional Benchmark Index</h6>
                                  <span>{AdditionalBenchmarkIndex}</span>
                                </li>
                              </ul>
                            </div>

                            {/* Minimum Application Amount */}
                            <div className="fund-flex">
                              <ul className="sub-head dots">
                                <li>
                                  <p className="hover-fund">
                                    Minimum Application Amount
                                    <span className="hover-text-summary">
                                      This is the minimum investment amount for
                                      a new investor in a mutual fund scheme
                                    </span>
                                  </p>
                                  <p>{renderHTML(MinimumApplicationAmount)}</p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                    ),
                  )}
              </>
            )}
          </div>
        )}
        {/* <div className="noDataDiv">
                    {(data.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''}
                </div> */}
        {/* {loadingshow ? <div className="textcentervertex">
                    <img src={animation} alt="Loading" />
                    <div className="model_popup">Please Wait...</div>
                </div> : ""
                } */}
        <div className="gradiant-head-flex">
          <div className="gradiant-head-box">
            {/* {(data.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}
            {loadingshow ? (
              <div className="textcentervertex HomeLoader">
                <img src={animation} alt="Loading" />
                <div className="model_popup">Please Wait...</div>
              </div>
            ) : (
              <div>
                {data && data.length === 0 ? (
                  <h5 className="errormsgComNew">No Data Available</h5>
                ) : (
                  <>
                    {console.log(data, "data")}
                    {data &&
                      data.map(({ Attributes, FundApproachPos }) => (
                        <>
                          <div className="gradiant-head-container">
                            <h3 className="gradiant-head left">
                              Fund attributes & approach
                            </h3>
                          </div>
                          <div className="gradiant-content">
                            <p className="text-13 text-700 mb-2">Attributes</p>
                            <div className="padding-box-inner">
                              {/* <p className="text-13 text-justify">
                                {Attributes && Attributes.trim != " " ? (
                                  Attributes
                                ) : (
                                  <h6 className="errorMsg">No Data Found</h6>
                                )}
                              </p> */}
                              <p className="text-13 text-justify">
                                {Attributes && Attributes !== "" ? (
                                  Attributes
                                ) : (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      fontSize: "15px",
                                      fontWeight: "bold",
                                      position: "relative",
                                      marginTop: "10px",
                                    }}
                                  >
                                    Since this is a new scheme, Attributes are
                                    not yet available
                                  </div>
                                )}
                              </p>
                            </div>
                            {data &&
                              data[0].FundCode !== "AA" &&
                              data[0].FundCode !== "ON" && (
                                <p className="text-13 text-700 mb-2 mt-3">
                                  Approach and Positioning
                                </p>
                              )}
                            {data[0].FundCode !== "AA" &&
                              data[0].FundCode !== "ON" && (
                                <div className="padding-box-inner">
                                  {/* <p className="text-13 text-justify">
                                {FundApproachPos != " " ? (
                                  FundApproachPos
                                ) : (
                                  <h6 className="errorMsg">No Data Found</h6>
                                )}
                              </p> */}
                                  <p className="text-13 text-justify">
                                    {FundApproachPos &&
                                    FundApproachPos !== "" ? (
                                      FundApproachPos
                                    ) : (
                                      <div
                                        style={{
                                          textAlign: "center",
                                          fontSize: "15px",
                                          fontWeight: "bold",
                                          position: "relative",
                                          marginTop: "10px",
                                        }}
                                      >
                                        Since this is a new scheme, Approach and
                                        Positioning are not yet available
                                      </div>
                                    )}
                                  </p>
                                </div>
                              )}
                          </div>
                        </>
                      ))}
                  </>
                )}
              </div>
            )}
            {/* {loadingshow ? <div className="textcentervertex">
                            <img src={animation} alt="Loading" />
                            <div className="model_popup">Please Wait...</div>
                        </div> : ""
                        } */}
          </div>
          <div className="gradiant-head-box">
            <div className="gradiant-head-container">
              <h3 className="gradiant-head">Fund Managers</h3>
            </div>
            {/* {(dataMan.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}
            {loadingshow ? (
              <div className="textcentervertex HomeLoader">
                <img src={animation} alt="Loading" />
                <div className="model_popup">Please Wait...</div>
              </div>
            ) : (
              <div>
                {dataMan && dataMan.length === 0 ? (
                  <h5 className="errormsgComNew">No Data Available</h5>
                ) : (
                  <>
                    {dataMan &&
                      dataMan.map(
                        ({ FundMgrMapId, Designation, Image, Name }) => (
                          <>
                            <div
                              className={`gradiant-content contentMan ${
                                Name === "Mr. Satish Ramanathan, CFA" &&
                                ["J656", "J658"].includes(SchemeCode)
                                  ? "manager-tooltip"
                                  : ""
                              }`}
                            >
                              {Name === "Mr. Satish Ramanathan, CFA" &&
                                ["J656", "J658"].includes(SchemeCode) && (
                                  <span className="manager-hover-text">
                                    Will advise on the asset allocation of the
                                    scheme
                                  </span>
                                )}
                              <ul className="fund-managers">
                                <li>
                                  <div className="managers-img-container">
                                    <img
                                      src={Image}
                                      alt={`${Name} - ${Designation}`}
                                    />
                                  </div>
                                  <div className="manager-detail">
                                    <p className="name text-sm text-700 textFund">
                                      {Name}
                                    </p>
                                    <p className="designation">{Designation}</p>
                                    <a
                                      href="#"
                                      role="button"
                                      className="managers_link"
                                      data-id={FundMgrMapId}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleShow(e);
                                      }}
                                    >
                                      Other Funds Managed by the FM
                                    </a>
                                    <Modal
                                      show={show}
                                      className="modal productModal"
                                    >
                                      <Modal.Body>
                                        <div className="btnDiv">
                                          <div onClick={handleClose}>
                                            <AiFillCloseCircle className="btncl" />
                                          </div>
                                        </div>
                                        <div className="bodyModalProduct">
                                          <div className="fundManPop">
                                            <div>
                                              <img
                                                src={
                                                  dataSum.length > 0
                                                    ? dataSum[0].Image
                                                    : ""
                                                }
                                                width="130px"
                                                alt={
                                                  dataSum.length > 0
                                                    ? dataSum[0].Image
                                                    : ""
                                                }
                                              />
                                            </div>
                                            <div>
                                              <p className="textNameMan">
                                                {dataSum.length > 0
                                                  ? dataSum[0].Name
                                                  : ""}
                                              </p>
                                              <p>
                                                {dataSum.length > 0
                                                  ? dataSum[0].Desc
                                                  : ""}
                                              </p>
                                            </div>
                                          </div>
                                          {/* {dataSum &&
                                            getDistinctValuesAsDict(
                                              dataSum,
                                              "AsonDate"
                                            ).map(({ AsonDate, index }) => (
                                              <p
                                                key={index}
                                                className="text-right DateAson"
                                              >
                                                <span className="">
                                                  As on -{" "}
                                                </span>
                                                {AsonDate != null
                                                  ? format(
                                                      parseISO(AsonDate),
                                                      "do MMM, yyyy"
                                                    )
                                                  : ""}
                                              </p>
                                            ))} */}
                                          {dataSum &&
                                            getDistinctValuesAsDict(
                                              dataSum,
                                              "AsonDate",
                                            ).map(
                                              ({ AsonDate, index }, idx) => (
                                                <React.Fragment key={index}>
                                                  {idx === 0 && ( // Render "As on -" only for the first item
                                                    <p className="text-right DateAson">
                                                      <span className="">
                                                        As on -{" "}
                                                      </span>
                                                      {AsonDate != null
                                                        ? format(
                                                            parseISO(AsonDate),
                                                            "do MMM, yyyy",
                                                          )
                                                        : ""}
                                                    </p>
                                                  )}
                                                  {idx !== 0 && ( // For subsequent items, render without "As on -"
                                                    <p className="text-right DateAson">
                                                      {AsonDate != null
                                                        ? format(
                                                            parseISO(AsonDate),
                                                            "do MMM, yyyy",
                                                          )
                                                        : ""}
                                                    </p>
                                                  )}
                                                </React.Fragment>
                                              ),
                                            )}

                                          <div className="table-responsive">
                                            <table className="table managaerPop">
                                              <thead>
                                                <tr>
                                                  <th rowspan="2">
                                                    Scheme Name
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    rowspan="2"
                                                  >
                                                    Managing since
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    colspan="4"
                                                  >
                                                    Period
                                                  </th>
                                                </tr>
                                                <tr>
                                                  <th
                                                    className="text-right"
                                                    colspan="1"
                                                  >
                                                    6 Months
                                                  </th>
                                                  <th
                                                    className="text-right"
                                                    colspan="1"
                                                  >
                                                    1 Years
                                                  </th>
                                                  <th
                                                    className="text-right"
                                                    colspan="1"
                                                  >
                                                    3 Years
                                                  </th>
                                                  <th
                                                    className="text-right"
                                                    colspan="1"
                                                  >
                                                    5 Years
                                                  </th>
                                                </tr>
                                                {/* <tr>
                                                                            <th></th>
                                                                            <th></th>
                                                                            <th className="text-right">Scheme<br></br> return (%)</th>
                                                                          
                                                                            <th className="text-right">Scheme<br></br> return (%)</th>
                                                                           
                                                                            <th className="text-right">Scheme<br></br>return (%)</th>
                                                                           
                                                                        </tr> */}
                                              </thead>
                                              {/* <tbody>
                                                {dataSum &&
                                                  dataSum.map(
                                                    ({
                                                      CAGR1Yr,
                                                      CAGR3Yr,
                                                      CAGR5Yr,
                                                      SAR6Mon,
                                                      CAGRInception,
                                                      Title,
                                                      MangingSince,
                                                    }) => (
                                                      <>
                                                        <tr>
                                                          <td>
                                                            {Title && Title}
                                                          </td>
                                                          <td className="text-center">
                                                            {format(
                                                              parseISO(
                                                                MangingSince &&
                                                                  MangingSince
                                                              ),
                                                              "dd-MMM-yyyy"
                                                            )}
                                                          </td>
                                                          <td className="text-right">
                                                            {SAR6Mon &&
                                                            SAR6Mon != null
                                                              ? SAR6Mon
                                                              : "-"}
                                                          </td>
                                                          <td className="text-right">
                                                            {CAGR1Yr &&
                                                            CAGR1Yr != null
                                                              ? CAGR1Yr
                                                              : "-"}
                                                          </td>
                                                          <td className="text-right">
                                                            {CAGR3Yr &&
                                                            CAGR3Yr != null
                                                              ? CAGR3Yr
                                                              : "-"}
                                                          </td>
                                                          <td className="text-right">
                                                            {CAGR5Yr &&
                                                            CAGR5Yr != null
                                                              ? CAGR5Yr
                                                              : "-"}
                                                          </td>
                                                          {/* <td>{CAGRInception}</td> */}
                                              {/* </tr>
                                                      </>
                                                    )
                                                  )}

                                              </tbody>  */}
                                              <tbody>
                                                {dataSum &&
                                                Array.isArray(dataSum) &&
                                                dataSum.length > 0 ? (
                                                  dataSum.map(
                                                    ({
                                                      CAGR1Yr,
                                                      CAGR3Yr,
                                                      CAGR5Yr,
                                                      SAR6Mon,
                                                      CAGRInception,
                                                      Title,
                                                      MangingSince,
                                                    }) => (
                                                      <tr>
                                                        <td>{Title}</td>
                                                        <td className="text-center">
                                                          {MangingSince
                                                            ? format(
                                                                parseISO(
                                                                  MangingSince,
                                                                ),
                                                                "dd-MMM-yyyy",
                                                              )
                                                            : "-"}
                                                        </td>
                                                        <td className="text-right">
                                                          {SAR6Mon != null
                                                            ? SAR6Mon
                                                            : "-"}
                                                        </td>
                                                        <td className="text-right">
                                                          {CAGR1Yr != null
                                                            ? CAGR1Yr
                                                            : "-"}
                                                        </td>
                                                        <td className="text-right">
                                                          {CAGR3Yr != null
                                                            ? CAGR3Yr
                                                            : "-"}
                                                        </td>
                                                        <td className="text-right">
                                                          {CAGR5Yr != null
                                                            ? CAGR5Yr
                                                            : "-"}
                                                        </td>
                                                        {/* <td>{CAGRInception}</td> */}
                                                      </tr>
                                                    ),
                                                  )
                                                ) : (
                                                  <tr>
                                                    <td
                                                      colSpan="6"
                                                      className="text-center"
                                                    >
                                                      No Data Found !!!
                                                    </td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                            <div className="popupManDesc">
                                              {/* <p>
                                                                        Period for which fund's performance has been provided is computed based on last day of the month-end preceding the date of advertisement
                                                                    </p> */}
                                              <p>
                                                Period for which fund's
                                                performance has been provided is
                                                computed based on last day of
                                                the Preceding month.
                                              </p>
                                              <p>
                                                Different plans shall have a
                                                different expense structure. The
                                                performance details provided
                                                herein are of regular plan.
                                              </p>
                                              <p>
                                                <b>
                                                  Past performance may or may
                                                  not be sustained in future and
                                                  should not be used as a basis
                                                  for comparison with other
                                                  investments.
                                                </b>
                                              </p>
                                              <p>
                                                <b>
                                                  The concerned fund manager
                                                  manages {dataSum.length}{" "}
                                                  number of schemes of the
                                                  concerned Mutual Fund.
                                                </b>
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </Modal.Body>
                                    </Modal>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </>
                        ),
                      )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="gradiant-head-flex">
          <Holdings getSchemeCode={getSchemeCode} />
          <RollingReturns
            getSchemeCode={getSchemeCode}
            getSchemeType={getSchemeType}
          />
        </div>
        <div className="investment-horizone-container">
          {/* {(data.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}
          {loadingshow ? (
            <div className="textcentervertex HomeLoader">
              <img src={animation} alt="Loading" />
              <div className="model_popup">Please Wait...</div>
            </div>
          ) : (
            <>
              {data && data.length === 0 ? (
                <h5 className="errormsgComNew">No Data Available</h5>
              ) : (
                <>
                  {data &&
                    data.map(({ RecommendedInvstHorizon, SuitableFor }) => (
                      <>
                        <div className="investment-horizone">
                          <div className="head">
                            <span>Recommended</span>
                            <span>Investment Horizon</span>
                          </div>

                          <div className="box">
                            <div className="img-container">
                              <img
                                src={product_horizon1}
                                alt=""
                                width={41}
                                height={41}
                              />
                            </div>
                            <p>{RecommendedInvstHorizon}</p>
                          </div>
                        </div>
                        <div className="suitable-for">
                          <div className="head text-center">Suitable For</div>

                          <div className="box-flex">
                            {/* ✅ Move error outside UL */}
                            {data && data.length === 0 ? (
                              <p className="errorMsg">No Data Found !!!</p>
                            ) : (
                              <ul>
                                {data &&
                                  data.map(
                                    ({
                                      SuitableFor1,
                                      SuitableForImage1,
                                      SuitableForImage2,
                                      SuitableFor2,
                                      SuitableForImage3,
                                      SuitableFor3,
                                      SuitableForImage4,
                                      SuitableFor4,
                                      SuitableForImage5,
                                      SuitableFor5,
                                    }) => (
                                      <>
                                        <div className="listSuitable">
                                          <li>
                                            {SuitableFor1 != null ? (
                                              <img
                                                src={SuitableForImage1}
                                                alt={SuitableFor1}
                                              ></img>
                                            ) : (
                                              <></>
                                            )}{" "}
                                            {SuitableFor1}
                                          </li>
                                          <li>
                                            {SuitableFor2 != null ? (
                                              <img
                                                src={SuitableForImage2}
                                                alt={SuitableFor2}
                                              ></img>
                                            ) : (
                                              <></>
                                            )}{" "}
                                            {SuitableFor2}
                                          </li>
                                          <li>
                                            {SuitableFor3 != null ? (
                                              <img
                                                src={SuitableForImage3}
                                                alt={SuitableFor3}
                                              ></img>
                                            ) : (
                                              <></>
                                            )}{" "}
                                            {SuitableFor3}
                                          </li>
                                          <li>
                                            {SuitableFor4 != null ? (
                                              <img
                                                src={SuitableForImage4}
                                                alt={SuitableFor4}
                                              ></img>
                                            ) : (
                                              <></>
                                            )}{" "}
                                            {SuitableFor4}
                                          </li>
                                          <li>
                                            {SuitableFor5 != null ? (
                                              <img
                                                src={SuitableForImage5}
                                                alt={SuitableFor5}
                                              ></img>
                                            ) : (
                                              <></>
                                            )}{" "}
                                            {SuitableFor5}
                                          </li>
                                        </div>

                                        {/* <li className="listSuitable">
                                                    
                                                </li>

                                                <li className="listSuitable">
                                                   
                                                </li> */}
                                        {/* <li className="listSuitable">
                                                    <img src={SuitableForImage2}></img> {SuitableFor}
                                                </li>
                                                <li className="listSuitable">
                                                    <img src={SuitableForImage1}></img> {SuitableFor1}
                                                </li>
                                                <li className="listSuitable">
                                                    <img src={SuitableForImage1}></img> {SuitableFor1}
                                                </li>
                                                <li className="listSuitable">
                                                    <img src={SuitableForImage1}></img> {SuitableFor1}
                                                </li> */}
                                      </>
                                    ),
                                  )}
                              </ul>
                            )}
                          </div>
                        </div>
                        {/* {loadingshow ? <div className="textcentervertex">
                                < img src={animation} alt="Loading" />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            } */}
                      </>
                    ))}
                </>
              )}
            </>
          )}
        </div>
      </section>
    </>
  );
}

export default FundSummery;
